<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Inspiration 2xfotoHeadingDES</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp1Image')"
            [blockData]="block.variables?.X2Exp1Image ?? ''"
            [placeholder]="image1Placeholder"
            variable="X2Exp1Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp2Image')"
            [blockData]="block.variables?.X2Exp2Image ?? ''"
            [placeholder]="image2Placeholder"
            variable="X2Exp2Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp1ImageHref')"
            [blockData]="block.variables?.X2Exp1ImageHref ?? ''"
            [placeholder]="image1HrefPlaceholder"
            variable="X2Exp1ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Exp1ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.X2Exp1ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp2ImageHref')"
            [blockData]="block.variables?.X2Exp2ImageHref ?? ''"
            [placeholder]="image2HrefPlaceholder"
            variable="X2Exp2ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Exp2ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.X2Exp2ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp1ImageAlt')"
            [blockData]="block.variables?.X2Exp1ImageAlt ?? ''"
            [placeholder]="image1AltPlaceholder"
            variable="X2Exp1ImageAlt"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp2ImageAlt')"
            [blockData]="block.variables?.X2Exp2ImageAlt ?? ''"
            [placeholder]="image2AltPlaceholder"
            variable="X2Exp2ImageAlt"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp1Heading')"
            [blockData]="block.variables?.X2Exp1Heading ?? ''"
            [placeholder]="heading1Placeholder"
            variable="X2Exp1Heading"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp2Heading')"
            [blockData]="block.variables?.X2Exp2Heading ?? ''"
            [placeholder]="heading2Placeholder"
            variable="X2Exp2Heading"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp1Description')"
            [blockData]="block.variables?.X2Exp1Description ?? ''"
            [placeholder]="description1Placeholder"
            variable="X2Exp1Description"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp2Description')"
            [blockData]="block.variables?.X2Exp2Description ?? ''"
            [placeholder]="description2Placeholder"
            variable="X2Exp2Description"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp1CtaLink')"
            [blockData]="block.variables?.X2Exp1CtaLink ?? ''"
            [placeholder]="ctaLink1Placeholder"
            variable="X2Exp1CtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Exp1CtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.X2Exp1CtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2Exp2CtaLink')"
            [blockData]="block.variables?.X2Exp2CtaLink ?? ''"
            [placeholder]="ctaLink2Placeholder"
            variable="X2Exp2CtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Exp2CtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.X2Exp2CtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X2Exp1CtaText')"
            [blockData]="block.variables?.X2Exp1CtaText ?? ''"
            [placeholder]="ctaText1Placeholder"
            variable="X2Exp1CtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X2Exp2CtaText')"
            [blockData]="block.variables?.X2Exp2CtaText ?? ''"
            [placeholder]="ctaText2Placeholder"
            variable="X2Exp2CtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>
        <div class="col-12">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2ExpParagraph')"
            [blockData]="block.variables?.X2ExpParagraph ?? ''"
            [placeholder]="paragraphPlaceholder"
            variable="X2ExpParagraph"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div
            class="col-12 mb-3"
            [innerHTML]="$safeNavigationMigration(block.variables?.X2ExpParagraph)"
          ></div>
          <div class="col-6" *ngIf="block.variables?.X2Exp1Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X2Exp1ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.X2Exp1Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.X2Exp1ImageAlt)"
            /></a>
          </div>
          <div class="col-6" *ngIf="block.variables?.X2Exp2Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X2Exp2ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.X2Exp2Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.X2Exp2ImageAlt)"
            /></a>
          </div>
        </div>
        <div class="row text-left mt-2">
          <div class="col-6">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X2Exp1Heading)"></p>
          </div>
          <div class="col-6">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X2Exp2Heading)"></p>
          </div>
        </div>
        <div class="row text-left mt-2">
          <div class="col-6">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X2Exp1Description)"></p>
          </div>
          <div class="col-6">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X2Exp2Description)"></p>
          </div>
        </div>
        <div class="row text-left mt-2">
          <div class="col-6">
            <a
              class="btn btn-primary"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X2Exp1CtaLink))"
              target="_blank"
              *ngIf="block.variables?.X2Exp1CtaLink"
              [innerHTML]="$safeNavigationMigration(block.variables?.X2Exp1CtaText)"
            ></a>
          </div>
          <div class="col-6">
            <a
              class="btn btn-primary"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X2Exp2CtaLink))"
              target="_blank"
              *ngIf="block.variables?.X2Exp2CtaLink"
              [innerHTML]="$safeNavigationMigration(block.variables?.X2Exp2CtaText)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
